<lx-dropdown-side-panel-field
  (ngModelChange)="onSelectValue($event)"
  (blurred)="markAsTouched()"
  [title]="title"
  [(ngModel)]="selectedValue"
  data-qa="residenceCountrySelector"
  [options]="residenceCountries"
  optionLabel="name"
  optionValue="code"
  [filter]="true"
  filterBy="name"
  placeholder="Select"
>
</lx-dropdown-side-panel-field>
